import { get } from '../core/client';
import { getLocalStorageItem } from '../core/utility';

const scrollToTop = (behavior: any = 'auto'): void => {
    const scrollElement = document?.getElementById('root');
    scrollElement?.scroll({
        top: 0,
        left: 0,
        behavior,
    });
};
interface IDate {
    firstDate?: Date;
    secondDate?: Date;
}
interface IDateFormat {
    date_: Date;
    seperator?: string;
    beginningDate?: 'day' | 'year';
}

const getDateFormat = ({ date_, seperator = '-', beginningDate = 'year' }: IDateFormat): string | null => {
    if (!date_) return null;
    if (date_ === undefined) return null;
    if (new Date(date_).getFullYear() < 1900) return 'Invalid Date';

    const month = new Date(date_).getMonth() + 1;
    const year = new Date(date_).getFullYear();
    const day = new Date(date_).getDate();
    if (beginningDate === 'year') {
        return year + seperator + (month < 10 ? '0' + month : month) + seperator + (day < 10 ? '0' + day : day);
    } else {
        return (day < 10 ? '0' + day : day) + seperator + (month < 10 ? '0' + month : month) + seperator + year;
    }
};

const compareDates = ({ firstDate, secondDate }: IDate): boolean | null => {
    const date1 = new Date(firstDate);
    const date2 = new Date(secondDate);

    const firstYear = date1.getFullYear();
    const firstMonth = date1.getMonth();
    const firstDay = date1.getDate();

    const secondYear = date2.getFullYear();
    const secondMonth = date2.getMonth();
    const secondDay = date2.getDate();

    if (!firstDate && !secondDate) return null;

    if (firstYear > secondYear) {
        return true;
    } else if (firstYear < secondYear) {
        return false;
    } else {
        if (firstMonth > secondMonth) {
            return true;
        } else if (firstMonth < secondMonth) {
            return false;
        } else {
            if (firstDay > secondDay) {
                return true;
            } else if (firstDay < secondDay) {
                return false;
            } else {
                return null;
            }
        }
    }
};

const isValidDate = (date: string): boolean | null => {
    const dateformat = /^(0?[1-9]|[1-2][0-9]|3[01])[/](0?[1-9]|1[0-2])/;

    // Matching the date through regular expression
    if (date.match(dateformat)) {
        const operator = date.split('/');

        // Extract the string into month, date and year
        let datepart = [];
        if (operator.length > 1) {
            datepart = date.split('/');
        }
        const day = parseInt(datepart[0]);
        const month = parseInt(datepart[1]);
        const year = parseInt(datepart[2]);

        // Create a list of days of a month
        const ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (month === 1 || month > 2) {
            if (day > ListofDays[month - 1]) {
                //to check if the date is out of range
                console.log('Invalid date');
                return false;
            }
        } else if (month === 2) {
            let leapYear = false;
            if ((!(year % 4) && year % 100) || !(year % 400)) leapYear = true;
            if (leapYear === false && day >= 29) {
                console.log('Invalid date');
                return false;
            } else if (leapYear === true && day > 29) {
                console.log('Invalid date format!');
                return false;
            }
        }
    } else {
        return false;
    }
    return true;
};

function isDate(obje: unknown): obje is Date {
    return obje instanceof Date && !isNaN(obje.getTime());
}

function onlyNumberRegex(value: string): void {
    //! only number regex
    const numberPatern = /^\d*$/;

    // Girilen değer regex deseniyle eşleşirse, input değerini kabul et
    if (numberPatern.test(value)) {
        console.log('Geçerli sayı girişi: ' + value);
    } else {
        console.log('Geçersiz giriş! Sadece sayı giriniz.');
        // İsteğe bağlı olarak geçersiz girişi temizleme veya uyarı mesajı gösterme işlemleri yapılabilir.
    }
}

const downloadFile = async (processCode: string): Promise<void> => {
    try {
        const response = await get<any>(processCode)

        const binaryContent = atob(response?.result?.fileContents);

        const arrayBuffer = new ArrayBuffer(binaryContent.length);
        const view = new Uint8Array(arrayBuffer);
        for (let i = 0; i < binaryContent.length; i++) {
            view[i] = binaryContent.charCodeAt(i);
        }

        const blob = new Blob([arrayBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const downloadLink = document.createElement('a');
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = response?.result?.fileDownloadName;

        downloadLink.click();
    } catch (error) {
        console.error(error);
    }
};

const userId = getLocalStorageItem('USER_ID');

export { userId, getDateFormat, compareDates, isValidDate, scrollToTop, isDate, onlyNumberRegex, downloadFile };
